import { InjectionToken } from '@angular/core'

export const CONTAINER_DATA = new InjectionToken<any>('CONTAINER_DATA')
